import Rails from 'rails-ujs';
import StarRating from 'vue-star-rating';
import Vue from 'vue/dist/vue.esm';
import { submitWithCommit } from './submit_with_commit';

Rails.start();

// spでの:active要素を反応させるため
window.addEventListener('touchstart', () => {}, false);

window.addEventListener('load', () => {
  const starRatingElements = Rails.$('.star_rating');

  if(starRatingElements.length == 0){
    return;
  }

  starRatingElements.forEach((el) => {
    new Vue({
      el,
      components: { StarRating },
      methods: {
        setRating(rating){
          this.$refs.ratingField.value = rating;
        }
      },
      data:{
        rating: 0
      }
    });
  });
});

window.onload = function() {
/* popup利用方法
   - 必要なViewに以下のコードを記述する。
     ※html_safeを呼び出し時につけないと勝手にエスケープされてしまうので注意
     ※popup_typeがhideの場合、モーダルをさせたいタグに `.js-modal-target` を記述しておく。
   ```
    - provide :popup_link_content, '<a class="btn_ellipse bg_clr_base txt_clr_wh middle" href="/pix/my"><span>OK</span></a>'.html_safe
    - provide :popup_message, 'hello<br>hello'.html_safe
    - provide :popup_type, 'default' or 'hide'
    - provide :popup_link_type, 'default' or 'cancelable'
    - provide :popup_close_text, '閉じるボタンのテキストを指定できる(オプション)'
    - provide :popup_wrapper_id, 'ここに閉じるボタンを押した時に閉じるポップアップのwrapperに付与するidをつける。'
      わかりやすい名前が良いです。これをつける事で1ページに複数のポップアップを置くことが出来るようになります。
      ここで設定したidをpopupを表示する`.js-modal-target`の`data-target-open`に設定。閉じるボタンに`data-target-close`に設定。
  ```
*/

  (function() {
    const popupLink = Rails.$('.js-modal-target');
    const closePopupLinks = Rails.$('.js-modal-close-target');
    const contentPopups = Rails.$('.content_popup');
    const boxContentPopup = Rails.$('.box_content_popup');
    let scrollY = 0;
    const iframeExist = document.getElementsByTagName("iframe").length != 0;

    if (popupLink.length != 0) {
      popupLink.forEach((popup_link) => {
        popup_link.addEventListener('click', (e) => {
          scrollY = window.pageYOffset;
          document.body.style = `position: fixed; top: -${scrollY}px;`;
          const target_popup_id = e.currentTarget.dataset.targetOpen;
          const target_popup = document.getElementById(target_popup_id);
          return target_popup.classList.remove('hide');
        });
      });
    }

    if (closePopupLinks.length != 0) {
      closePopupLinks.forEach((closePopupLink) => {
        closePopupLink.addEventListener('click', (e) => {
          // ブラウザバックを閉じる瞬間の画面上部からの位置
          // ブラウザバックを閉じた時のガクッとする問題を解決
          scrollY = Math.abs(parseInt(document.body.style.top));
          document.body.style = "position: static;";
          setTimeout(() => {
            window.scrollTo( 0, scrollY );
          }, 0);
          // アンカーリンクに移動させる場合にはdocument.body.style設定後に移動させる
          if (e.currentTarget.classList.contains('with-anchor-link')) {
            setTimeout(() => {
              window.location.href = `#special_present_0`;
            }, 1000);
          }
          // [js-modal-close-only]クラスがあるものは×ボタンを押したモーダルだけ非表示にする
          if (e.currentTarget.classList.contains('js-modal-close-only')) {
            const target_popup_id = e.currentTarget.dataset.targetClose;
            const target_popup = document.getElementById(target_popup_id);
            target_popup.classList.add('hide');
          } else {
            contentPopups.forEach((contentPoup) => {
              if (iframeExist) {
                document.getElementsByTagName("iframe")[0].src = '';
              }
              contentPoup.classList.add('hide');
            });
          }
        });
      });
    }

    if (contentPopups.length != 0) {
      contentPopups.forEach((contentPopup) => {
        contentPopup.addEventListener('click', () => {
          // ブラウザバックを閉じる瞬間の画面上部からの位置
          // ブラウザバックを閉じた時のガクッとする問題を解決
          scrollY = Math.abs(parseInt(document.body.style.top));
          document.body.style = "position: static;";
          setTimeout(() => {
             window.scrollTo( 0, scrollY );
          }, 0);
          if (iframeExist) {
            document.getElementsByTagName("iframe")[0].src = '';
          }
          contentPopup.classList.add('hide');
        });
      });
    }

    if (boxContentPopup.length != 0) {
      boxContentPopup.forEach((box_content_popup) => {
        box_content_popup.addEventListener('click', (e) => {
          e.stopPropagation();
          if (closePopupLinks.length != 0 && e.currentTarget.classList.contains('js-modal-close-target')) {
            const target_popup_id = e.currentTarget.getAttribute('data-target-close');
            const target_popup = document.getElementById(target_popup_id);
            document.body.style = "position: static;";
            setTimeout(() => {
              window.scrollTo( 0, scrollY );
            }, 0);
            if (iframeExist) {
              document.getElementsByTagName("iframe")[0].src = '';
            }
            return target_popup.classList.add('hide');
          }
        });
      });
    }

    // ポップアップを表示させる時に、画面にヘッダーを表示させたくないため、スタイルを当てる
    const contentPopupAfterLoaded = Rails.$('.content_popup_after_loaded');
    if (contentPopupAfterLoaded.length != 0) {
      document.body.style =  `position: fixed; top: -50px;`;
    }
  }());
};

window.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-submit-with-commit]').forEach((button) => {
    button.addEventListener('click', () => {
      const form = button.form;
      const commit = button.dataset.submitWithCommit;
      submitWithCommit(form, commit);
    });
  });
});
